import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ExpenseReportContentContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "diffHeight" && prop !== "isManagedByLink" && prop !== "forExport",
})<{ diffHeight?: number; isManagedByLink?: boolean; forExport?: boolean }>(
  ({ theme }) => ({
    width: "100%",
    height: "65vh",
    overflow: "auto",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: "20px",
  }),
  ({ isManagedByLink, diffHeight }) => ({
    ...(!!isManagedByLink && {
      height: `calc(100% - ${(diffHeight ?? 0) + 25}px)`,
      overflow: "hidden",
    }),
  }),
  ({ forExport }) => ({
    ...(!!forExport && {
      height: "100%",
      flexDirection: "column",
      gap: "0px",
    }),
  })
);
